import Table, { TableProps, TablePaginationConfig } from './Table';
export default Table;
